
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'
import { useSearchParams } from "react-router-dom"

export const WaterQuantityPreventiveWorkExportData = (props) => {
    const { ExcelData, name, searchName, RoleID, Date } = props

    const [searchParams] = useSearchParams()
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')

    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '48%' }}>

                <h5><span>&emsp;</span></h5>

                {
                    (DashProjectTypeId == '6' && RoleID != '16') ?
                        <>
                            <tr>
                                <th colSpan={9} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Navi Mumbai Municipal Corporation</th>
                            </tr>
                            <tr>
                                <th colSpan={9} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>WATER SUPPLY DEPARTMENT</th>
                            </tr>
                            {
                                (DashProjectTypeId == '6' && RoleID != '16') ?
                                    <tr>
                                        <th colSpan={9} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Project Name: - {(ExcelData && ExcelData.table && ExcelData.table[0].projectName) ? (ExcelData && ExcelData.table && ExcelData.table[0].projectName) : '-'}</th>
                                    </tr>
                                    :
                                    <tr>
                                        <th colSpan={9} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Project Name: - Main Feeder - Morbe Dam to Digha</th>
                                    </tr>
                            }
                            <tr>
                                <th colSpan={9} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Report Name: {name}</th>
                            </tr>
                            <tr>
                                <th colSpan={9} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Date:- {Date ? Date : '-'} </th>
                            </tr>
                        </>

                        :
                        <>
                            <tr>
                                <th colSpan={7} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Navi Mumbai Municipal Corporation</th>
                            </tr>
                            <tr>
                                <th colSpan={7} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>WATER SUPPLY DEPARTMENT</th>
                            </tr>
                            {
                                (DashProjectTypeId == '6' && RoleID != '16') ?
                                    <tr>
                                        <th colSpan={7} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Project Name: - {ExcelData.table[0].projectName}</th>
                                    </tr>
                                    :
                                    <tr>
                                        <th colSpan={7} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Project Name: - Main Feeder - Morbe Dam to Digha</th>
                                    </tr>
                            }
                            <tr>
                                <th colSpan={7} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Report Name: {name}</th>
                            </tr>
                            <tr>
                                <th colSpan={7} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Date:- {Date ? Date : '-'} </th>
                            </tr>
                        </>

                }
                {/* <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white' }}>
                        <th className="sr_no_col">Sr No.</th>
                        <th>Date</th>
                        <th>Pumping Station</th>
                        <th>KPI Name</th>
                        <th>Present</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item) => {
                            return (
                                <tr style={{ width: '100%' }}>
                                    <td style={{ textAlign: "left" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                    <td style={{ textAlign: "left" }}>{item.readingDate ? item.readingDate : '-'}</td>
                                    <td style={{ textAlign: "left" }}>{item.pumpStation ? item.pumpStation : '-'}</td>
                                    <td style={{ textAlign: "left" }}>{item.houseKeepingType ? item.houseKeepingType : '-'}</td>
                                    <td style={{ textAlign: "left" }}>{item.indicatorName ? item.indicatorName : '-'}</td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody> */}

                {
                    (DashProjectTypeId == '6' && RoleID != '16') ?
                        <>
                            {/* <table id="totalordergenerated"
                                cellPadding="0"
                                cellSpacing="0"
                                border="0"
                                className="table table-bordered "

                            > */}

                            <thead >
                                <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                                    <th rowSpan={2} className='new_grid' style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                                    {
                                        (DashProjectTypeId == '6' && RoleID != '16') ?
                                            <th rowSpan={2} className='new_grid'>Location</th>
                                            :
                                            <th rowSpan={2} className='new_grid'>Junction</th>
                                    }
                                    <th rowSpan={2} className='new_grid'>Pipe Size</th>
                                    <th colspan="3" className='new_grid'>Incoming Flow</th>
                                    <th colspan="3" className='new_grid' style={{ borderRight: "1px solid black" }}>Outgoing Flow</th>
                                    {/* <th rowSpan={2} className='new_grid'>Action</th> */}
                                </tr>
                                <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white' }}>
                                    <th className='new_grid'>Yesterday Reading</th>
                                    <th className='new_grid'>Today's Reading</th>
                                    <th className='new_grid'>Incoming Water in MLD</th>
                                    <th className='new_grid'>Yesterday Reading</th>
                                    <th className='new_grid'>Today's Reading</th>
                                    <th className='new_grid' style={{ borderRight: "1px solid black" }}>Outgoing Water in MLD</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item, i) => (
                                        <tr style={{ width: "100%", border: "1px solid black" }}>
                                            <td style={{ textAlign: "center" }}>{i + 1}</td>
                                            {
                                                (DashProjectTypeId == '6' && RoleID != '16') ?
                                                    <td>{item.locationDetails ? item.locationDetails : '-'}</td>
                                                    :
                                                    <td>{item.junctionDetails ? item.junctionDetails : '-'}</td>
                                            }
                                            <td>{item.pipelineDetails ? item.pipelineDetails : '-'}</td>
                                            <td style={{ textAlign: "right" }}>{item.incomingInitialReading ? item.incomingInitialReading : '0'}</td>
                                            <td style={{ textAlign: "right" }}>{item.incomingFinalReading ? item.incomingFinalReading : '0'}</td>
                                            <td style={{ textAlign: "right" }}>{item.incomingWaterINMLD ? item.incomingWaterINMLD : '0'}</td>
                                            <td style={{ textAlign: "right" }}>{item.outgoingInitialReading ? item.outgoingInitialReading : '0'}</td>
                                            <td style={{ textAlign: "right" }}>{item.outgoingFinalReading ? item.outgoingFinalReading : '0'}</td>
                                            <td style={{ textAlign: "right" }}>{item.outgoingWaterINMLD ? item.outgoingWaterINMLD : '0'}</td>
                                            {/* <td style={{ textAlign: "center" }}>
                                                                                {
                                                                                    (moment(item.readingDate).format('YYYY-MM-DD')) == (moment().format('YYYY-MM-DD')) ?
                                                                                        <>
                                                                                            <span>
                                                                                                <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                                    style={{ cursor: 'pointer' }}
                                                                                                    onClick={() => handleEditOnClick(item)}
                                                                                                >
                                                                                                </i>
                                                                                            </span>
                                                                                            <span>
                                                                                                <DeletePopup
                                                                                                    open={DeletePopupShow}
                                                                                                    item={item}
                                                                                                    handleDeleteApi={handleDeleteApi}
                                                                                                />
                                                                                            </span>
                                                                                        </>
                                                                                        :
                                                                                        '-'
                                                                                }
                                                                            </td> */}
                                        </tr>
                                    )) :
                                        <td colSpan={15}>No data found</td>
                                }
                            </tbody>
                            {/* </table> */}
                        </>
                        :
                        <>
                            {/* <table id="totalordergenerated"
                                cellPadding="0"
                                cellSpacing="0"
                                border="0"
                                className="table table-bordered "

                            > */}

                            <thead >
                                <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                                    <th rowSpan={2} className='new_grid' style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                                    <th rowSpan={2} className='new_grid'>Reading Date</th>
                                    <th rowSpan={2} className='new_grid'>Junction</th>
                                    <th rowSpan={2} className='new_grid'>Pipe Size</th>
                                    <th colspan="2" className='new_grid'>Water Reading</th>
                                    <th rowSpan={2} className='new_grid' style={{ borderRight: "1px solid black" }}>Water in MLD</th>
                                    {/* <th rowSpan={2} className='new_grid'>Action</th> */}
                                </tr>
                                <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white' }}>
                                    <th className='new_grid'>Yesterday Reading</th>
                                    <th className='new_grid' style={{ borderRight: "1px solid white" }}>Today's Reading</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item, i) => (
                                        <tr style={{ width: "100%", border: "1px solid black" }}>
                                            <td style={{ textAlign: "center" }}>{i + 1}</td>
                                            <td>{item.readingDate ? moment(item.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                            <td>{item.junctionDetails ? item.junctionDetails : '-'}</td>
                                            <td>{item.pipelineDetails ? item.pipelineDetails : '0'}</td>
                                            <td>{item.yesterdayReading ? item.yesterdayReading : '0'}</td>
                                            <td>{item.todayReading ? item.todayReading : '0'}</td>
                                            <td>{item.waterINMLD ? item.waterINMLD : '0'}</td>
                                            {/* <td style={{ textAlign: "center" }}>
                                                                                {
                                                                                    (moment(item.readingDate).format('YYYY-MM-DD')) == (moment().format('YYYY-MM-DD')) ?
                                                                                        <>
                                                                                            <span >

                                                                                                <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                                    style={{ cursor: 'pointer' }}
                                                                                                    onClick={() => handleEditOnClick(item)}
                                                                                                >
                                                                                                </i>
                                                                                            </span>
                                                                                            <span>
                                                                                                <DeletePopup
                                                                                                    open={DeletePopupShow}
                                                                                                    handleDeleteApi={handleDeleteApi}
                                                                                                    item={item}
                                                                                                />
                                                                                            </span>
                                                                                        </>
                                                                                        :
                                                                                        '-'
                                                                                }
                                                                            </td> */}
                                        </tr>
                                    )) :
                                        <td colSpan={15}>No data found</td>
                                }
                            </tbody>
                            {/* </table> */}
                        </>
                }

            </table>
        </div>
    )
}